import { render, staticRenderFns } from "./TileTotalDowntime.vue?vue&type=template&id=0594b2a0"
import script from "./TileTotalDowntime.vue?vue&type=script&lang=js"
export * from "./TileTotalDowntime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports